<div class="gaps-pursuits-container">
  <div class="gaps-pursuits-container__grid-sub-header">
    <div class="gaps-pursuits-container__show-all-chases-checkbox">
      <p-checkbox label="Show All Gaps"
                  [(ngModel)]="nonActionableChasesChecked"
                  binary="true">
      </p-checkbox>
    </div>
  </div>
  <app-gap-grid [addressId]="addressId"
                [(selection)]="selection"
                [additionalColumns]="additionalColumns"
                [additionalFilters]="additionalFilters"
                [additionalBulkActions]="additionalBulkActions"
                [isSelectionModeMultiple]=true
                [rowDisabledCondition]="disabledRowsFilter"
                [hideDisabledRows]="hideDisabledRows"
                [isLoadOnInit]="true">
  </app-gap-grid>

  <app-retrieval-outreach [(visible)]="isGapChaseOutreachModalVisible"
                          (onHide)="gapChasePursuitOutreachModalHide()"
                          [selectedChaseList]="selectedChaseNumeratorList"
                          [additionalOutreachChaseList]="openChases"
                          [isGap]="true"
                          [gapType]="gapType">
  </app-retrieval-outreach>

  <app-retrieval-outreach [(visible)]="isGapPursuitOutreachModalVisible"
                          (onHide)="gapChasePursuitOutreachModalHide()"
                          [selectedChaseList]="selectedChaseNumeratorList"
                          [additionalOutreachChaseList]="openChases"
                          [isGap]="true"
                          [gapType]="gapType">
  </app-retrieval-outreach>

  <app-confirmation-modal [(visible)]="isAdditionalOutreachPromptVisible"
                          header="ATTENTION"
                          acceptText="Yes"
                          rejectText="Close"
                          (onYes)="navigateToAdditionalOutreachTab()"
                          class="text-center">
    This Address also has Open Chases.
    <br /><br />
    Would you like to perform Outreach for the Chases as well?
    <br /><br />
    <div class="bold">
      Total Chases : {{ additionalChaseOutreachCount }}
    </div>
    <br />

  </app-confirmation-modal>

  <app-pend-modal [(visible)]="isPendModalVisible"
                  (onHide)="unSelectGridSelection()"
                  (onUpdate)="gapGridComponent.refreshGrid.emit()"
                  [(chases)]="selectedChases"
                  [clinical]="clinical">
  </app-pend-modal>

  <retrieval-address-search [(visible)]="isAddressModalVisible"
                            [callingSource]="addressSearchCallingSource"
                            (onAddressSelection)="onAddressSelectionForChaseMove($event)">
  </retrieval-address-search>

  <app-confirmation-modal [(visible)]="isChaseMoveVisible"
                          header="Are you sure you want to move these chases?"
                          rejectText="CANCEL"
                          (onYes)="intiateChaseMove()"
                          class="text-center">
  </app-confirmation-modal>

  <app-confirmation-modal [(visible)]="isViewPostMoveVisible"
                          acceptText="VIEW THIS ADDRESS"
                          rejectText="CANCEL"
                          (onYes)="gotoAddressDetail()"
                          class="text-center">
    {{confirmMoveStatusMessage}}
  </app-confirmation-modal>

  <retrieval-commitment-date [(visible)]="isCommitmentDateModalVisible"
                             [updateCommitmentData]="commitDateUpdateModel"
                             (onUpdate)="gapGridComponent.refreshGrid.emit()"
                             (onHide)="unSelectGridSelection()"
                             [(commitDate)]="commitmentDate">
  </retrieval-commitment-date>

  <app-print-provider-packet-modal [(visible)]="isGapChasePrintProviderPacketModalVisible"
                                   (onHide)="gapPrintProviderModalHide()"
                                   [providerPacketItem]="providerPacketItem"
                                   [gapType]="gapType">
  </app-print-provider-packet-modal>

  <app-print-provider-packet-modal [(visible)]="isGapPursuitPrintProviderPacketModalVisible"
                                   (onHide)="gapPrintProviderModalHide()"
                                   [providerPacketItem]="providerPacketItem"
                                   [gapType]="gapType">
  </app-print-provider-packet-modal>

  <app-manage-tag-modal [(visible)]="isManageTagModalVisible"
                        (onHide)="unSelectGridSelection()"
                        [(selectedData)]="selectedChases"
                        [entityName]="entityName"
                        [totalEntityCount]="totalEntityCount"
                        [tagType]="tagType"
                        (onUpdate)="gapGridComponent.refreshGrid.emit()">
  </app-manage-tag-modal>

</div>
